/** @jsx jsx */
import { jsx } from '@emotion/react';
import Spinner from '@atlaskit/spinner';
import { rootContainerStylesForLoader } from '../link-picker/styled';
export const LoaderFallback = jsx("div", {
  css: rootContainerStylesForLoader,
  "data-testid": "link-picker-root-loader-boundary-ui"
}, jsx(Spinner, {
  testId: "link-picker.component-loading-indicator",
  size: "medium"
}));